import React from 'react';
import { useNotification } from '../../hooks/useNotification';

const NotificationToast = () => {
  const { notifications, removeNotification } = useNotification();

  const types = {
    success: {
      bg: 'bg-green-50',
      border: 'border-green-500',
      text: 'text-green-800',
      icon: ''
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-500',
      text: 'text-red-800',
      icon: ''
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-500',
      text: 'text-yellow-800',
      icon: ''
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-500',
      text: 'text-blue-800',
      icon: ''
    }
  };

  return (
    <div className="fixed top-4 right-4 z-[9999] space-y-2">
      {notifications.map((notification) => {
        const style = types[notification.type] || types.info;
        return (
          <div
            key={notification.id}
            className={`${style.bg} ${style.text} border-l-4 ${style.border} p-4 rounded shadow-lg max-w-md animate-slide-in`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <span className="font-bold text-xl">{style.icon}</span>
                <p className="text-sm">{notification.message}</p>
              </div>
              <button
                onClick={() => removeNotification(notification.id)}
                className="ml-4 text-gray-400 hover:text-gray-600"
              >
                X
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default NotificationToast;
